export default function AttackLegend({ visible }: { visible: boolean }) {
  return (
    <table className={`attack-legend ${visible && 'attack-legend--visible'}`}>
      <thead>
        <tr>
          <th>Attack</th>
          <th>Beats</th>
          <th>Loses To</th>
          <th>Ties</th>
        </tr>
      </thead>
      <tbody>
        <tr data-id="fire">
          <td>Fire</td>
          <td>Timber, Metal</td>
          <td>Water, Earth</td>
          <td>Fire (Higher HP wins)</td>
        </tr>
        <tr data-id="water">
          <td>Water</td>
          <td>Fire, Metal</td>
          <td>Earth, Timber</td>
          <td>Water (Higher HP wins)</td>
        </tr>
        <tr data-id="earth">
          <td>Earth</td>
          <td>Water, Fire</td>
          <td>Timber, Metal</td>
          <td>Earth (Higher HP wins)</td>
        </tr>
        <tr data-id="timber">
          <td>Timber</td>
          <td>Water, Earth</td>
          <td>Fire, Metal</td>
          <td>Timber (Higher HP wins)</td>
        </tr>
        <tr data-id="metal">
          <td>Metal</td>
          <td>Timber, Earth</td>
          <td>Fire, Water</td>
          <td>Metal (Higher HP wins)</td>
        </tr>
      </tbody>
      <caption className="battle-legend-caption">
          💀 Dead Warriors lose tie breakers to living Warriors.
      </caption>
    </table>
  );
}
